














import { Component, Vue } from "vue-property-decorator";
import QuickMitsumori from "@/page/factory/quickMitsumori.vue";
@Component
export default class QuickMitsumoriUser extends QuickMitsumori {
  onConfirmExit() {
    this.$router.push({ name: "usermenu" });
  }
}
